import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

// App
import { ConfirmationDialogProps } from "../../../../types";
import useConfirmationStyles from "./styles";
import { XCloseButton } from "../../Buttons";

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  contentText,
  contentTitle,
  open,
  onClose,
  onConfirm,
  closeText,
  confirmText,
  children,
  disabled,
  confirmOnly,
  size = "-",
}) => {
  const confirmationStyles = useConfirmationStyles();
  return (
    <Modal isOpen={open} toggle={onClose} size={size}>
      <div style={confirmationStyles.confirmationContainer}>
        <div style={confirmationStyles.flex}>
          <ModalHeader style={confirmationStyles.title}>
            {contentTitle}
            <div style={confirmationStyles.btnClose}>
              <XCloseButton closeActionHandler={onClose} />
            </div>
          </ModalHeader>
        </div>

        <div style={confirmationStyles.contentBox}>
          <ModalBody style={confirmationStyles.text}>
            {contentText}
            {children}
          </ModalBody>
        </div>

        <ModalFooter>
          {disabled ? (
            <div>Loading...</div>
          ) : (
            <>
              {!confirmOnly && (
                <Button color="secondary" onClick={onClose}>
                  {closeText}
                </Button>
              )}
              <Button color="primary" onClick={onConfirm} disabled={disabled}>
                {confirmText}
              </Button>
            </>
          )}
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default ConfirmationDialog;
